// Aplana un VTT (el formato que produce el Worker de transcripción, ver
// lib/transcription.ts) a texto plano: sin cabecera WEBVTT, sin líneas de
// timestamp, sin números de cue, sin líneas vacías extra. Se usa solo como
// insumo del Quiz IA (Video.transcriptText) — ver
// openspec/changes/video-transcript-for-quizzes.
const TIMESTAMP_LINE = /-->/
const CUE_NUMBER_LINE = /^\d+$/

export function flattenVttToPlainText(vtt: string): string {
  return vtt
    .split(/\r?\n/)
    .filter((line) => {
      const trimmed = line.trim()
      if (trimmed === "" || trimmed === "WEBVTT") return false
      if (TIMESTAMP_LINE.test(trimmed)) return false
      if (CUE_NUMBER_LINE.test(trimmed)) return false
      return true
    })
    .join(" ")
    .replace(/\s+/g, " ")
    .trim()
}
